module.exports = __webpack_public_path__ + "static/media/roadside.c1fdc57e.jpg";